import { render } from "./MediaplanComparison.vue?vue&type=template&id=3324dba4&scoped=true"
import script from "./MediaplanComparison.vue?vue&type=script&lang=js"
export * from "./MediaplanComparison.vue?vue&type=script&lang=js"

import "./MediaplanComparison.vue?vue&type=style&index=0&id=3324dba4&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3324dba4"]])

export default __exports__